import { html, type TemplateResult } from 'lit';

export function renderRemarksAndNews(remarksAndNewsData: {
    title: string;
    content: string | null | undefined;
}): TemplateResult | null {
    if (!remarksAndNewsData?.content) {
        return null;
    }

    return html`
        <div class="productinfo-remarks-news">
            <der-ui-tile title="${remarksAndNewsData.title}" content="${remarksAndNewsData.content}"></der-ui-tile>
        </div>
    `;
}
